import React, { useState } from 'react';
import { Container, Table, Button, Badge, Row, Col, Pagination } from 'react-bootstrap';

const PayoutBeneficiaries = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(8);

  // Mock data - 10 records for each tab
  const pendingData = [
    {
      id: 'PB001',
      beneficiaryName: 'Rajesh Kumar',
      accountNumber: '1234567890',
      ifscCode: 'SBIN0001234',
      mobileNumber: '9876543210',
      requestDate: '2024-01-15',
      amount: 5000
    },
    {
      id: 'PB002',
      beneficiaryName: 'Amit Sharma',
      accountNumber: '2345678901',
      ifscCode: 'HDFC0002345',
      mobileNumber: '9123456789',
      requestDate: '2024-01-16',
      amount: 7500
    },
    {
      id: 'PB003',
      beneficiaryName: 'Priya Singh',
      accountNumber: '3456789012',
      ifscCode: 'ICIC0003456',
      mobileNumber: '9988776655',
      requestDate: '2024-01-17',
      amount: 3200
    },
    {
      id: 'PB004',
      beneficiaryName: 'Vikram Malhotra',
      accountNumber: '4567890123',
      ifscCode: 'AXIS0004567',
      mobileNumber: '9876512345',
      requestDate: '2024-01-18',
      amount: 12000
    },
    {
      id: 'PB005',
      beneficiaryName: 'Sonia Gupta',
      accountNumber: '5678901234',
      ifscCode: 'SBIN0005678',
      mobileNumber: '9123467890',
      requestDate: '2024-01-19',
      amount: 8500
    },
    {
      id: 'PB006',
      beneficiaryName: 'Ravi Shankar',
      accountNumber: '6789012345',
      ifscCode: 'HDFC0006789',
      mobileNumber: '9876598765',
      requestDate: '2024-01-20',
      amount: 4500
    },
    {
      id: 'PB007',
      beneficiaryName: 'Meera Iyer',
      accountNumber: '7890123456',
      ifscCode: 'ICIC0007890',
      mobileNumber: '9123498765',
      requestDate: '2024-01-21',
      amount: 6000
    },
    {
      id: 'PB008',
      beneficiaryName: 'Karan Kapoor',
      accountNumber: '8901234567',
      ifscCode: 'AXIS0008901',
      mobileNumber: '9876501234',
      requestDate: '2024-01-22',
      amount: 9500
    },
    {
      id: 'PB009',
      beneficiaryName: 'Anjali Mehta',
      accountNumber: '9012345678',
      ifscCode: 'SBIN0009012',
      mobileNumber: '9123412345',
      requestDate: '2024-01-23',
      amount: 11000
    },
    {
      id: 'PB010',
      beneficiaryName: 'Deepak Rao',
      accountNumber: '0123456789',
      ifscCode: 'HDFC0000123',
      mobileNumber: '9876509876',
      requestDate: '2024-01-24',
      amount: 7800
    }
  ];

  const approvedData = [
    {
      id: 'PB011',
      beneficiaryName: 'Suresh Patel',
      accountNumber: '1234567891',
      ifscCode: 'AXIS0001234',
      mobileNumber: '9876512345',
      requestDate: '2024-01-10',
      approvedDate: '2024-01-12',
      amount: 12000
    },
    {
      id: 'PB012',
      beneficiaryName: 'Neha Verma',
      accountNumber: '2345678902',
      ifscCode: 'SBIN0002345',
      mobileNumber: '9123467890',
      requestDate: '2024-01-11',
      approvedDate: '2024-01-13',
      amount: 8500
    },
    {
      id: 'PB013',
      beneficiaryName: 'Arun Singh',
      accountNumber: '3456789013',
      ifscCode: 'HDFC0003456',
      mobileNumber: '9988776655',
      requestDate: '2024-01-12',
      approvedDate: '2024-01-14',
      amount: 15000
    },
    {
      id: 'PB014',
      beneficiaryName: 'Pooja Reddy',
      accountNumber: '4567890124',
      ifscCode: 'ICIC0004567',
      mobileNumber: '9876543211',
      requestDate: '2024-01-13',
      approvedDate: '2024-01-15',
      amount: 6500
    },
    {
      id: 'PB015',
      beneficiaryName: 'Manish Joshi',
      accountNumber: '5678901235',
      ifscCode: 'AXIS0005678',
      mobileNumber: '9123456790',
      requestDate: '2024-01-14',
      approvedDate: '2024-01-16',
      amount: 9800
    },
    {
      id: 'PB016',
      beneficiaryName: 'Divya Nair',
      accountNumber: '6789012346',
      ifscCode: 'SBIN0006789',
      mobileNumber: '9876501235',
      requestDate: '2024-01-15',
      approvedDate: '2024-01-17',
      amount: 13500
    },
    {
      id: 'PB017',
      beneficiaryName: 'Rahul Desai',
      accountNumber: '7890123457',
      ifscCode: 'HDFC0007890',
      mobileNumber: '9123412346',
      requestDate: '2024-01-16',
      approvedDate: '2024-01-18',
      amount: 7200
    },
    {
      id: 'PB018',
      beneficiaryName: 'Sneha Kulkarni',
      accountNumber: '8901234568',
      ifscCode: 'ICIC0008901',
      mobileNumber: '9876509877',
      requestDate: '2024-01-17',
      approvedDate: '2024-01-19',
      amount: 10500
    },
    {
      id: 'PB019',
      beneficiaryName: 'Vishal Chauhan',
      accountNumber: '9012345679',
      ifscCode: 'AXIS0009012',
      mobileNumber: '9123498766',
      requestDate: '2024-01-18',
      approvedDate: '2024-01-20',
      amount: 5500
    },
    {
      id: 'PB020',
      beneficiaryName: 'Kavita Shah',
      accountNumber: '0123456780',
      ifscCode: 'SBIN0000124',
      mobileNumber: '9876543212',
      requestDate: '2024-01-19',
      approvedDate: '2024-01-21',
      amount: 14000
    }
  ];

  const rejectedData = [
    {
      id: 'PB021',
      beneficiaryName: 'Mohan Das',
      accountNumber: '1234567892',
      ifscCode: 'HDFC0001235',
      mobileNumber: '9876598765',
      requestDate: '2024-01-08',
      rejectedDate: '2024-01-09',
      reason: 'Invalid account details',
      amount: 4500
    },
    {
      id: 'PB022',
      beneficiaryName: 'Kavita Jain',
      accountNumber: '2345678903',
      ifscCode: 'ICIC0002346',
      mobileNumber: '9123498765',
      requestDate: '2024-01-09',
      rejectedDate: '2024-01-10',
      reason: 'Duplicate request',
      amount: 6000
    },
    {
      id: 'PB023',
      beneficiaryName: 'Ramesh Yadav',
      accountNumber: '3456789014',
      ifscCode: 'AXIS0003457',
      mobileNumber: '9988776656',
      requestDate: '2024-01-10',
      rejectedDate: '2024-01-11',
      reason: 'Insufficient documents',
      amount: 8200
    },
    {
      id: 'PB024',
      beneficiaryName: 'Sunita Pillai',
      accountNumber: '4567890125',
      ifscCode: 'SBIN0004568',
      mobileNumber: '9876543213',
      requestDate: '2024-01-11',
      rejectedDate: '2024-01-12',
      reason: 'Account mismatch',
      amount: 5800
    },
    {
      id: 'PB025',
      beneficiaryName: 'Ajay Bhat',
      accountNumber: '5678901236',
      ifscCode: 'HDFC0005679',
      mobileNumber: '9123456791',
      requestDate: '2024-01-12',
      rejectedDate: '2024-01-13',
      reason: 'Invalid IFS Code',
      amount: 7500
    },
    {
      id: 'PB026',
      beneficiaryName: 'Preeti Saxena',
      accountNumber: '6789012347',
      ifscCode: 'ICIC0006790',
      mobileNumber: '9876501236',
      requestDate: '2024-01-13',
      rejectedDate: '2024-01-14',
      reason: 'Fraudulent activity',
      amount: 12000
    },
    {
      id: 'PB027',
      beneficiaryName: 'Nitin Agarwal',
      accountNumber: '7890123458',
      ifscCode: 'AXIS0007891',
      mobileNumber: '9123412347',
      requestDate: '2024-01-14',
      rejectedDate: '2024-01-15',
      reason: 'Inactive account',
      amount: 4200
    },
    {
      id: 'PB028',
      beneficiaryName: 'Rekha Menon',
      accountNumber: '8901234569',
      ifscCode: 'SBIN0008902',
      mobileNumber: '9876509878',
      requestDate: '2024-01-15',
      rejectedDate: '2024-01-16',
      reason: 'Name mismatch',
      amount: 9300
    },
    {
      id: 'PB029',
      beneficiaryName: 'Sachin Dubey',
      accountNumber: '9012345680',
      ifscCode: 'HDFC0009013',
      mobileNumber: '9123498767',
      requestDate: '2024-01-16',
      rejectedDate: '2024-01-17',
      reason: 'Duplicate account',
      amount: 6700
    },
    {
      id: 'PB030',
      beneficiaryName: 'Lata Srinivasan',
      accountNumber: '0123456781',
      ifscCode: 'ICIC0000125',
      mobileNumber: '9876543214',
      requestDate: '2024-01-17',
      rejectedDate: '2024-01-18',
      reason: 'Bank verification failed',
      amount: 11500
    }
  ];

  const columns = {
    pending: [
      { key: 'actions', label: 'Actions' },
      { key: 'id', label: 'ID' },
      { key: 'beneficiaryName', label: 'Beneficiary Name' },
      { key: 'accountNumber', label: 'Account Number' },
      { key: 'ifscCode', label: 'IFS Code' },
      { key: 'mobileNumber', label: 'Mobile Number' },
      { key: 'amount', label: 'Amount' },
      { key: 'requestDate', label: 'Request Date' }
    ],
    approved: [
      { key: 'id', label: 'ID' },
      { key: 'beneficiaryName', label: 'Beneficiary Name' },
      { key: 'accountNumber', label: 'Account Number' },
      { key: 'ifscCode', label: 'IFS Code' },
      { key: 'mobileNumber', label: 'Mobile Number' },
      { key: 'amount', label: 'Amount' },
      { key: 'requestDate', label: 'Request Date' },
      { key: 'approvedDate', label: 'Approved Date' }
    ],
    rejected: [
      { key: 'id', label: 'ID' },
      { key: 'beneficiaryName', label: 'Beneficiary Name' },
      { key: 'accountNumber', label: 'Account Number' },
      { key: 'ifscCode', label: 'IFS Code' },
      { key: 'mobileNumber', label: 'Mobile Number' },
      { key: 'amount', label: 'Amount' },
      { key: 'requestDate', label: 'Request Date' },
      { key: 'rejectedDate', label: 'Rejected Date' },
      { key: 'reason', label: 'Reason' }
    ]
  };

  const getCurrentData = () => {
    switch (activeTab) {
      case 'pending':
        return pendingData;
      case 'approved':
        return approvedData;
      case 'rejected':
        return rejectedData;
      default:
        return [];
    }
  };

  // Pagination logic
  const currentData = getCurrentData();
  const totalPages = Math.ceil(currentData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedData = currentData.slice(startIndex, endIndex);

  // Reset to page 1 when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  // Pagination component
  const renderPagination = () => {
    const items = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    // Previous button
    items.push(
      <Pagination.Prev 
        key="prev" 
        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
      />
    );

    // Page numbers
    for (let page = startPage; page <= endPage; page++) {
      items.push(
        <Pagination.Item
          key={page}
          active={page === currentPage}
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </Pagination.Item>
      );
    }

    // Next button
    items.push(
      <Pagination.Next 
        key="next" 
        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages}
      />
    );

    return items;
  };

  const handleApprove = (id) => {
    console.log('Approve beneficiary:', id);
    // Add your approve logic here
  };

  const handleReject = (id) => {
    console.log('Reject beneficiary:', id);
    // Add your reject logic here
  };

  return (
    <Container fluid className="p-4">
      <div className="user-table-container">
        {/* Header */}
        <Row className="mb-4">
          <Col>
            <h4 className="mb-0" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
              <i className="bi bi-people me-2"></i>
              Payout Beneficiaries
            </h4>
          </Col>
        </Row>

        {/* Tabs */}
        <Row className="mb-3">
          <Col>
            <div className="d-flex gap-2">
              <Button
                onClick={() => handleTabChange('pending')}
                style={{
                  padding: '0.6rem 1.5rem',
                  fontWeight: '600',
                  background: activeTab === 'pending' ? '#667eea' : 'transparent',
                  border: '2px solid #667eea',
                  color: activeTab === 'pending' ? 'white' : '#667eea',
                  transition: 'all 0.3s ease',
                  borderRadius: '8px'
                }}
              >
                <i className="bi bi-clock me-2"></i>
                Pending ({pendingData.length})
              </Button>
              <Button
                onClick={() => handleTabChange('approved')}
                style={{
                  padding: '0.6rem 1.5rem',
                  fontWeight: '600',
                  background: activeTab === 'approved' ? '#10b981' : 'transparent',
                  border: '2px solid #10b981',
                  color: activeTab === 'approved' ? 'white' : '#10b981',
                  transition: 'all 0.3s ease',
                  borderRadius: '8px'
                }}
              >
                <i className="bi bi-check-circle me-2"></i>
                Approved ({approvedData.length})
              </Button>
              <Button
                onClick={() => handleTabChange('rejected')}
                style={{
                  padding: '0.6rem 1.5rem',
                  fontWeight: '600',
                  background: activeTab === 'rejected' ? '#ef4444' : 'transparent',
                  border: '2px solid #ef4444',
                  color: activeTab === 'rejected' ? 'white' : '#ef4444',
                  transition: 'all 0.3s ease',
                  borderRadius: '8px'
                }}
              >
                <i className="bi bi-x-circle me-2"></i>
                Rejected ({rejectedData.length})
              </Button>
            </div>
          </Col>
        </Row>

        {/* Table */}
        <div className="table-responsive" style={{ background: '#f0f2f5', borderRadius: '12px', padding: '0' }}>
          <Table bordered hover className="modern-table" style={{ background: '#f0f2f5' }}>
            <thead style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
              <tr>
                {columns[activeTab].map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((row, index) => (
                  <tr key={index} style={{ background: '#f0f2f5' }}>
                    {activeTab === 'pending' && (
                      <td>
                        <div className="d-flex gap-1 justify-content-center">
                          <Button
                            size="sm"
                            variant="danger"
                            onClick={() => handleReject(row.id)}
                            title="Reject"
                            style={{
                              padding: '0.25rem 0.5rem',
                              fontSize: '0.75rem'
                            }}
                          >
                            <i className="bi bi-x-lg"></i>
                          </Button>
                          <Button
                            size="sm"
                            variant="success"
                            onClick={() => handleApprove(row.id)}
                            title="Approve"
                            style={{
                              padding: '0.25rem 0.5rem',
                              fontSize: '0.75rem'
                            }}
                          >
                            <i className="bi bi-check-lg"></i>
                          </Button>
                        </div>
                      </td>
                    )}
                    <td>{row.id}</td>
                    <td>{row.beneficiaryName}</td>
                    <td>{row.accountNumber}</td>
                    <td>{row.ifscCode}</td>
                    <td>{row.mobileNumber}</td>
                    <td><strong>₹{row.amount.toLocaleString()}</strong></td>
                    <td>{row.requestDate}</td>
                    {activeTab === 'approved' && (
                      <td>{row.approvedDate}</td>
                    )}
                    {activeTab === 'rejected' && (
                      <>
                        <td>{row.rejectedDate}</td>
                        <td>
                          <Badge bg="danger" style={{ fontSize: '0.8rem' }}>
                            {row.reason}
                          </Badge>
                        </td>
                      </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns[activeTab].length} className="text-center py-4">
                    <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                    <span className="text-muted">No {activeTab} beneficiaries found</span>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Pagination Controls */}
        {currentData.length > 0 && (
          <Row className="align-items-center mt-4 pt-3" style={{ borderTop: '1px solid #f0f0f0' }}>
            <Col lg={6} md={6} sm={12} className="mb-2 mb-md-0">
              <span style={{ 
                fontSize: '0.9rem', 
                color: '#64748b',
                fontWeight: '500'
              }}>
                Showing <strong style={{ color: '#667eea' }}>{startIndex + 1}</strong> to <strong style={{ color: '#667eea' }}>{Math.min(endIndex, currentData.length)}</strong> of <strong style={{ color: '#667eea' }}>{currentData.length}</strong> entries
              </span>
            </Col>
            <Col lg={6} md={6} sm={12} className="d-flex justify-content-end">
              <Pagination className="mb-0">{renderPagination()}</Pagination>
            </Col>
          </Row>
        )}
      </div>
    </Container>
  );
};

export default PayoutBeneficiaries;

